import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { UserService } from '../services/user.service';
import { tokenNotExpired } from 'angular2-jwt/angular2-jwt';

@Injectable()
export class AdminGuard implements CanActivate {
  constructor(public userService: UserService) {}

  canActivate() {
    return tokenNotExpired && this.userService.user && this.userService.user.userType === this.userService.Admin;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/admin.guard.ts